type Endpoint = 'advisor' | 'client' | 'submitAssessment';

export const fetchData = async (endpoint: Endpoint, id?: string) => {
  let url = `${process.env.REACT_APP_SAGE_URL}/`;

  switch (endpoint) {
    case 'advisor':
      url += `advisor?id=${id}`;
      break;
    case 'client':
      url += `client?id=${id}`;
      break;
    case 'submitAssessment':
      break;
    default:
      throw new Error('Invalid type specified');
  }
  const response = await fetch(url, {
    headers: {
      authentication: process.env.REACT_APP_SAGE_AUTHORIZATION_TOKEN ?? '',
    },
  });

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  return response.json();
};
